import React from "react";

import { useNavigate } from "react-router-dom";

// import { ModalComentarios } from "common/components/Comentarios";
import { ModalComunicaciones } from "components/Portfolio/Lista/Comunicaciones/Row/Comunicaciones";
import { useAppSelector } from "store/store";

export const ComentariosActivo: React.FC = () => {
	const navigate = useNavigate();
	const iteSelected = useAppSelector((state) => state.ites.iteSelected);

	return (
		// <ModalComentarios asset={iteSelected.data?.asset} onClose={() => navigate(-1)} />
		<ModalComunicaciones asset={iteSelected.data?.asset} onClose={() => navigate(-1)} />
	);
};
